import { observer } from "mobx-react-lite";
import { CustomButton } from "ui";
import { useStores } from "stores";
import { OPERATION_TYPE } from "interfaces";
import { ConfirmOtpModal } from "components/ConfirmOtpModal";
import { formatWithDecimals } from "utils";

export const ReceivedRubButton = observer(() => {
  const { actionModals, bidCard } = useStores();

  const showModalHandler = () => {
    actionModals.open(
      () => (
        <ConfirmOtpModal
          description={`Подтверждаю, что средства в размере ${formatWithDecimals(bidCard?.bid?.amountRub, 2)} руб. переведены на р/с получателя`}
          operationPath={OPERATION_TYPE.BANK_TRANSFER_WITHDRAWN}
        />
      ),
      {
        title: "Подтвердите действие",
        width: "600px",
        noValidation: true,
        isOverlayClose: false,
      }
    );
  };

  return <CustomButton onClick={showModalHandler}>Рубли отправлены</CustomButton>;
});
